<template>
    <div class="modal fade" id="managePointsDialogModal" tabindex="-1" role="dialog" aria-labelledby="managePointsDialogModalTitle" aria-hidden="true" ref="modal">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="managePointsDialogModalTitle">Manage points</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p v-if="getPoints.length == 0">
                        You have not added any points.
                    </p>
                    <table v-else class="table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Latitude</th>
                                <th>Longitude</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="point in getPoints" :key="point.id">
                                <td>{{ point.name }}&nbsp;({{ point.cid }})</td>
                                <td>{{ point.lat.toFixed(2) }}</td>
                                <td>{{ point.lon.toFixed(2) }}</td>
                                <td><a href="#" @click="deletePoint(point.id)">Delete</a>&nbsp;&nbsp;&nbsp;<a href="#" @click="editPoint(point.id)">Edit</a></td>
                            </tr>
                        </tbody>                        
                    </table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
import $ from '@/lib/JQuery.js'
import { ServiceController } from '@/lib/ServiceController.js'
import events from '@/lib/events.js'

export default {
    name: 'ManagePointDialog',
    methods: {
        show() {
            $(this.$refs.modal).modal('show')
        },
        deletePoint(id) {
            ServiceController.deleteUserPoint(id)
        },
        editPoint(id) {
            let point = this.getPoints.find((p) => p.id == id)
            
            $(this.$refs.modal).modal('hide')
            events.$emit(events.ACTION_EDIT_POINT, point.lat, point.lon, point.name, point.id)
        }
    },
    computed: {
        getPoints() {
            let points = this.$store.state.userPoints
            if (points == null)
                points = []
            return points
        }
    }
}
</script>

<style>

</style>
